<template>
    <div id="main">
        <div class="page">
            <div class="sc-cidade">
                <h1 class="title">{{ $t('status-comercial-cidade') }} </h1>
                <nav class="breadcrumb" aria-label="breadcrumbs">
                    <ul>
                        <li><a>{{$t('vendas')}}</a></li>
                        <li><a>{{$t('geoanalise')}}</a></li>
                        <li><a href="#" aria-current="page">{{$t('status-comercial-cidade')}}</a></li>
                    </ul>
                </nav>

                <!-- Mapa -->
                <div class="mapa-wrapper" :class="isLoading ? 'disabled' : ''">
                    <GoogleMaps ref="gmap" :zoom="4" :heatmapMarkers="markers" :heatmapOptions="hMapOptions" :heatmap="true" :options="mapstyle"/>
                </div>

                <!-- Botão de retrair -->
                <div 
                    ref="retractBtn"
                    class="retract-button"
                    :class="{'hide-control-right-btn': !showStatus}"
                    v-show="!isLoading && !$root.gmapsFailure"                    
                >
                    <div class="btn-wrapper" @click="showStatus = !showStatus">
                        <b-icon :icon="showStatus ? 'chevron-right' : 'chevron-left'"/>
                    </div>
                </div>
                <!-- Lista de Vendedores - Dentro do Mapa -->
                <div
                    ref="listaStatus"
                    class="control-right"
                    :class="{'hide-control-right': !showStatus}"
                    v-show="!isLoading && !$root.gmapsFailure"
                >
                    <!-- Alert container movido pra dentro da lista que fica dentro do maps; Permite que os avisos apareçam em full screen -->
                    <alert-container :messages="msgs"/>
                    <div class="control-container">
                        <!-- Abas -->
                        <div class="control-tabs">
                            <ul class="nav nav-tabs">
                                <li
                                    v-for="(a, i) in abas"
                                    :class="{'active': abaAtual == i}"
                                    :key="i"
                                    @click="abaAtual = i"
                                >
                                    <a data-toggle="tab" href="#">{{$t(a)}}</a>
                                </li>
                            </ul>
                        </div>
                        <!-- Aba Clientes -->
                        <div class="lista-status" v-show="abaAtual == 0">
                            <search-bar class="search-input" :onSearch="debouncedOnSearch" disableTitle />
                            <div class="table-controls">
                                <div class="status-header" @click="switchSortTo('cliente')" :class="{'disabled': isSearching}">
                                    {{ $t('status-comercial') }}
                                    <svg class="svg-icons" v-show="orderedBy == 'cliente' && orderedAsc">
                                        <use :xlink:href="require('@/assets/img/icons/arrow-up.svg')+'#layer'"></use>
                                    </svg>
                                    <svg class="svg-icons" v-show="orderedBy == 'cliente' && !orderedAsc">
                                        <use :xlink:href="require('@/assets/img/icons/arrow-down.svg')+'#layer'"></use>
                                    </svg>
                                </div>
                                <div class="cliente-header" @click="switchSortTo('quantidade')" :class="{'disabled': isSearching}">
                                    {{ $t('clientes') }}
                                    <svg class="svg-icons" v-show="orderedBy == 'quantidade' && orderedAsc">
                                        <use :xlink:href="require('@/assets/img/icons/arrow-up.svg')+'#layer'"></use>
                                    </svg>
                                    <svg class="svg-icons" v-show="orderedBy == 'quantidade' && !orderedAsc">
                                        <use :xlink:href="require('@/assets/img/icons/arrow-down.svg')+'#layer'"></use>
                                    </svg>
                                </div>
                            </div>
                            <div class="columns is-mobile lista-wrapper">
                                <div class="column is-paddingless lista-container">
                                    <div class="columns is-multiline is-mobile" :class="isSearching ? 'disabled' : ''">
                                        <div class="column is-full lista-item" v-for="(s, i) in status" :key="i" :class="s.isLoading ? 'disabled' : ''">
                                            <div class="status-info">
                                                <div class="info-left">
                                                    <div class="check-div">
                                                        <label class="check-box" v-show="s.qtd > 0">
                                                            <input
                                                                :ref="`chk-${s.descricao}`"
                                                                type="checkbox" 
                                                                v-model="visibilityMap[s.tipo].checked"
                                                                @change="toggleStatus(s)"
                                                            />
                                                            <span class="checkmark"/>
                                                        </label>
                                                    </div>
                                                    <div 
                                                        @click="openDetails(s)"
                                                        :style="s.qtd == 0 ? 'padding-right: 16px;' : ''"
                                                    >
                                                        <b-icon
                                                            :icon="s.detailsOpen ? 'chevron-down' : 'chevron-right'"
                                                            size="is-small"
                                                            custom-size="mdi-18px"
                                                            v-if="s.qtd > 0"
                                                        />
                                                    </div>
                                                    <div style="width: 100%" @click="openDetails(s)">
                                                        <span>
                                                            {{ s.descricao.toUpperCase() }}
                                                        </span>
                                                    </div>
                                                </div>
                                                <div class="info-right" @click="openDetails(s)">
                                                    {{ s.qtd }} - {{ format(totalClientes > 0 ? s.qtd / totalClientes : 0) }}
                                                </div>
                                            </div>
                                            <b-collapse 
                                                :open="s.detailsOpen"
                                            >
                                                <div class="column is-full lista-cidades" v-for="(c, i) in s.cities" :key="i">
                                                    <div class="status-info">
                                                        <div class="info-left">
                                                            <label class="check-box">
                                                                <input
                                                                    :ref="`chk-${s.descricao}-${c.nome}-${c.estado}`"
                                                                    type="checkbox" 
                                                                    v-model="visibilityMap[s.tipo][c.id].checked"
                                                                    @change="toggleStatusCity(s, c)"
                                                                />
                                                                <span class="checkmark"/>
                                                            </label>
                                                            <div @click="c.detailsOpen = !c.detailsOpen">
                                                                <b-icon
                                                                    :icon="c.detailsOpen ? 'chevron-down' : 'chevron-right'"
                                                                    size="is-small"
                                                                    custom-size="mdi-18px"
                                                                />
                                                            </div>
                                                            <span @click="c.detailsOpen = !c.detailsOpen">
                                                                {{ c.nome ? `${c.nome}${c.estado ? ` - ${c.estado}` : ''} (${c.clientes.length})` : `*** ${$t('sem-cidade').toLocaleUpperCase()} ***`}}
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <b-collapse 
                                                        :open="c.detailsOpen"
                                                    >
                                                        <div class="column is-full lista-clientes" v-for="(cl, i) in c.clientes" :key="i">
                                                            <div class="status-info">
                                                                <div class="info-left">
                                                                    <label class="check-box">
                                                                        <input  type="checkbox" 
                                                                                v-model="visibilityMap[s.tipo][c.id][cl.idcliente].visible" 
                                                                                @change="toggleStatusClient(s, c, cl)"
                                                                        />
                                                                        <span class="checkmark"/>
                                                                    </label>
                                                                    <span class="text">
                                                                        {{ cl.rsocial }}
                                                                        <br>
                                                                        {{ $t('ultima-compra-em') + ' ' + $moment(cl.dataultimavenda).format("L") }}
                                                                        <br>
                                                                        {{ $t('sem-compra-a-n-dias', { n: cl.diferencadias }) }}
                                                                        <br>
                                                                        {{ $t('vendedor-abrev') + ': ' + cl.vendedor }}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </b-collapse>
                                                </div>
                                            </b-collapse>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="table-count">
                                <div :class="isSearching ? 'disabled' : ''">
                                    {{$t('clientes')}}: {{ totalClientes }}
                                </div>
                            </div>
                        </div>
                        <!-- Aba Filtros -->
                        <div class="filtros-main" v-show="abaAtual == 1">
                            <label v-text="$t('atividade')"/>
                            <v-select
                                class="smaller"
                                @search="loadAtividades"
                                :options="atividades"
                                :disabled="isSearching"
                                v-model="atividade"
                            >
                                <template
                                    slot="no-options"
                                >{{$t('sem-resultados-filtro') }}</template>
                            </v-select>
                            <label v-text="$t('regiao')"/>
                            <v-select
                                class="smaller"
                                @search="loadRegioes"
                                :options="regioes"
                                :disabled="isSearching"
                                v-model="regiao"
                            >
                                <template
                                    slot="no-options"
                                >{{$t('sem-resultados-filtro')}}</template>
                            </v-select>
                            <vss-select
                                title="situacao"
                                class="smaller"
                                @search="loadSituacoes"
                                :options="situacoes"
                                :disabled="isSearching"
                                :closeOnSelect="false"
                                v-model="situacao"
                                :tooltipMultilined="true"
                                tooltipPosition="is-right"
                                tooltipLabel="situacao-incluidos-inativos"
                                tooltipSize="is-small"
                                multiple
                                clearable
                                searchable
                            />
                        </div>
                        <div class="filter-footer-right p-5-custom is-flex is-flex-hright">
                            <b-button
                                type="is-silver"
                                icon-right="backspace"
                                @click="removeFilter"
                                class="mr-2"
                                :disabled="isLoading"
                            >
                                {{ $t('limpar') }}
                            </b-button>
                            <b-button
                                type="is-primary"
                                icon-right="filter"
                                @click="applyFilter"
                                :disabled="isLoading"
                            >
                                {{ $t('filtrar') }}
                            </b-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import GeoanaliseService from "@/services/GeoanaliseService";
import SituacaoService from "@/services/SituacaoService";
import FiltroRelatorioService from "@/services/FiltroRelatorioService";
import paleta from "@/functions/color/paleta.js";
import * as Styles from "@/functions/color/mapStyles/gmapstyle.js";
import GoogleMaps from "@/components/shared/maps/MapasGoogleMaps";
import Message from "@/models/Message";

export default {
    components: {
        GoogleMaps,
    },
    data() {
        return {
            situacaoService: new SituacaoService(this.$http, this.$router),
            isLoading: true,
            isSearching: false,
            searchVal: '',
            abas: ['clientes', 'filtros'],
            abaAtual: 0,
            status: [],
            markers: [],
            hMapOptions: {
                radius: 15,
                maxIntensity: 10,
            },
            visibilityMap: {},
            colors: [],
            totalClientes: 0,
            mapstyle: {
                mapTypeControl: false,
                streetViewControl: false,
                scaleControl: false,
                zoomControl: false,
                fullscreenControl: true,
                styles: Styles.grayscale
            },
            msgs: [],
            showStatus: true,
            orderedBy: '',
            orderedAsc: null,
            // filtro: { atividade: { descricao: "ATACADO" }, situacao: { descricao: "ATIVO"}, regiao: { descricao: "SUL 2"} },
            filtro: {},
            atividades: [],
            atividade: null,
            situacoes: [],
            situacao: null,
            regioes: [],
            regiao: null,
            permissao: {},
        };
    },
    created () {
        this.permissao = this.hasPermissionAccess('vendas', 'relatorio-geoanalise', 'mapa-status-comercial-cidade');

        !this.permissao.read && this.$router.push({
            name: 'acesso-nao-permitido',
            params: { tela: 'status-comercial-cidade' },
        });

        this.isLoading = true;
        this.colors = paleta.colorList;
        this.service = new GeoanaliseService(this.$http, this.$router);
        this.filterService = new FiltroRelatorioService(this.$http, this.$router);

        this.debouncedOnSearch = this.debounce(this.searchClientes, 500);
        this.loadAtividades('');
        this.loadRegioes('');

        this.service
            .findAll({}, '')
            .then(body => {
                let m = [];
                let total = 0;

                body.forEach(s => {
                    let status = this.status.find(st => st.tipo == s.tipo);

                    s.clients.forEach(c => {
                        m.push({
                            idcidade: c.cidade ? c.cidade.idcidade : 0,
                            idcliente: c.idcliente,
                            lat: c.latitude, 
                            lng: c.longitude, 
                            status: s.tipo, 
                            visible: true
                        });
                    });
                });

                this.markers = m;

                body.forEach(s => {
                    total += s.clients.length;

                    this.visibilityMap[s.tipo] = {};
                    this.visibilityMap[s.tipo].checked = true;
                    this.visibilityMap[s.tipo].visible = s.clients.length > 0;

                    s.clients.forEach(c => {
                        let idcidade = c.cidade != undefined ? c.cidade.idcidade : 0;

                        if (this.visibilityMap[s.tipo][idcidade] == undefined) {
                            this.visibilityMap[s.tipo][idcidade] = {};
                            this.visibilityMap[s.tipo][idcidade].checked = true;
                            this.visibilityMap[s.tipo][idcidade].visible = true;
                            this.visibilityMap[s.tipo][idcidade].inSearch = true;
                        }

                        this.visibilityMap[s.tipo][idcidade][c.idcliente] = {};
                        this.visibilityMap[s.tipo][idcidade][c.idcliente].visible = true;
                        this.visibilityMap[s.tipo][idcidade][c.idcliente].inSearch = true;
                    });
                });

                this.totalClientes = total;

                this.status = body.map(c => {
                    return {
                        descricao: c.descricao,
                        tipo: c.tipo,
                        cities: [],
                        qtd: c.clients.length,
                        hasDetails: false,
                        detailsOpen: false,
                        isLoading: false
                    }
                });

                this.$refs.gmap.$refs.mapRef.$mapPromise.then(map => {
                    let bounds = new google.maps.LatLngBounds();
                    
                    this.markers.forEach(m => {
                        bounds.extend(new google.maps.LatLng(m.lat, m.lng));
                    });

                    map.fitBounds(bounds);

                    setTimeout(() => {
                        this.gmnoprintZindex();
                    }, 1000);
                });

                this.isLoading = false;
            })
            .catch((error) => {
                this.msgs.push(new Message("error", 'msg-erro-relatorio', true));
                console.error('Erro ao carregar clientes:');
                console.error(error);
            });
    },
    mounted () {
        this.$refs.gmap.addCustomControl(8, this.$refs.listaStatus);
        this.$refs.gmap.addCustomControl(8, this.$refs.retractBtn);
    },
    methods: {
        loadSituacoes(){
            this.situacaoService.findAllVendas("descricao", "desc", 0, 50, 1)
                .then(this.mapItemsSituacao)
                .then(r => {
                    this.situacoes = r;
                
                });
        },
        mapItemsSituacao (body) {
            let list = body.content.map(i => {
                return {
                    id: i.idsituacao,
                    label: i.descricao
                };
            });

            return list;
        },
        toggleStatus (s) {
            this.visibilityMap[s.tipo].visible = this.visibilityMap[s.tipo].checked;

            if (s.hasDetails) {
                s.cities.forEach(c => {
                    if (this.$refs[`chk-${s.descricao}-${c.nome}-${c.estado}`] != undefined) {
                        this.$refs[`chk-${s.descricao}-${c.nome}-${c.estado}`][0].indeterminate = false;
                    }
                });
            }

            for (var prop in this.visibilityMap[s.tipo]) {
                if (prop != 'visible' && prop != 'checked') {
                    this.visibilityMap[s.tipo][prop].visible = this.visibilityMap[s.tipo].visible;
                    this.visibilityMap[s.tipo][prop].checked = this.visibilityMap[s.tipo].visible;

                    for (var cprop in this.visibilityMap[s.tipo][prop]) {
                        if (cprop != 'visible' && cprop != 'inSearch' && cprop != 'checked' && this.visibilityMap[s.tipo][prop].inSearch) {                                
                            this.visibilityMap[s.tipo][prop][cprop].visible = this.visibilityMap[s.tipo].visible;
                        }
                    }   
                }
            }

            this.updateHeatmap();
        },
        toggleStatusCity (s, c) {
            let visible = 0, invisible = 0;

            this.visibilityMap[s.tipo][c.id].visible = this.visibilityMap[s.tipo][c.id].checked;

            c.clientes.forEach(cl => {
                this.visibilityMap[s.tipo][c.id][cl.idcliente].visible = this.visibilityMap[s.tipo][c.id].visible;
            });
            
            s.cities.forEach(c => {
                this.visibilityMap[s.tipo][c.id].visible ? visible++ : invisible++;
            });

            this.visibilityMap[s.tipo].visible = visible > 0;

            if (this.$refs != undefined) {
                this.$refs[`chk-${s.descricao}`][0].indeterminate = visible > 0 && invisible > 0;
            }

            this.updateHeatmap();
        },
        toggleStatusClient (s, c, cl) {
            let visible = 0,    invisible = 0,
                visibleCl = 0,  invisibleCl = 0;

            c.clientes.forEach(cli => {
                this.visibilityMap[s.tipo][c.id][cli.idcliente].visible ? visible++ : invisible++;
            });

            s.cities.forEach(ci => {
                ci.clientes.forEach(cli => {
                    this.visibilityMap[s.tipo][ci.id][cli.idcliente].visible ? visibleCl++ : invisibleCl++;
                });
            });

            this.visibilityMap[s.tipo].visible = visibleCl > 0;
            this.visibilityMap[s.tipo].checked = visibleCl > 0;

            this.visibilityMap[s.tipo][c.id].visible = visible > 0;
            this.visibilityMap[s.tipo][c.id].checked = visible > 0;

            if (this.$refs != undefined) {
                this.$refs[`chk-${s.descricao}`][0].indeterminate = visibleCl > 0 && invisibleCl > 0;
                this.$refs[`chk-${s.descricao}-${c.nome}-${c.estado}`][0].indeterminate = visible > 0 && invisible > 0;
            }

            this.updateHeatmap();
        },
        updateHeatmap () {
            this.markers.forEach(m => {
                m.visible = this.visibilityMap[m.status].visible &&
                            this.visibilityMap[m.status][m.idcidade].visible && this.visibilityMap[m.status][m.idcidade].inSearch &&
                            this.visibilityMap[m.status][m.idcidade][m.idcliente].visible && this.visibilityMap[m.status][m.idcidade][m.idcliente].inSearch;
            });

            this.$forceUpdate();
        },
        openDetails (s) {
            if (!s.isLoading && s.qtd > 0) {
                if (s.hasDetails) {
                    s.detailsOpen = !s.detailsOpen;
                } else {
                    s.isLoading = !this.isSearching;
                    this.service.findByStatus(s.tipo, this.filtro, this.searchVal)
                        .then(c => {
                            return this.groupCity(c, s)
                        })
                        .then(c => {
                            c.cities.sort((a, b) => {
                                return `${a.nome} - ${a.estado ? ` - ${a.estado}` : ''}`.localeCompare(`${b.nome} - ${b.estado ? ` - ${b.estado}` : ''}`);
                            });

                            s.cities = c.cities;
                            s.hasDetails = true;
                            s.detailsOpen = true;
                            s.isLoading = false;
                            this.$refs[`chk-${s.descricao}`][0].indeterminate = false;
                        });
                }
            }
        },
        getLabel (option) {
            return this.$t(option.label);
        },
        format (number) {
            return number.toLocaleString(undefined, 
                {
                    style: 'percent',
                    minimumFractionDigits: 0, 
                    maximumFractionDigits: 2
                }
            );
        },
        getDate (dateString) {
            // Considerando formato 'YYYY-MM-DD'
            let d = dateString.split('-');

            // Criando o Date usando argumentos separados por conta do Safari
            // Usando Date('YYYY-MM-DD') ou Date('YYYY-MM-DDT00:00:00Z') volta a data um dia por conta do timezone
            return new Date(d[0], d[1] - 1, d[2]).toLocaleDateString();
        },
        getMarkers (body) {
            let m = [];

            body.forEach(s => {
                let status = this.status.find(st => st.tipo == s.tipo);

                s.clients.forEach(c => {
                    let cidadeid = c.cidade ? c.cidade.idcidade : 0;

                    m.push({
                        idcidade: cidadeid,
                        idcliente: c.idcliente,
                        lat: c.latitude, 
                        lng: c.longitude, 
                        status: s.tipo, 
                        visible: this.visibilityMap[s.tipo].visible &&
                                 this.visibilityMap[s.tipo][cidadeid].visible && this.visibilityMap[s.tipo][cidadeid].inSearch &&
                                 this.visibilityMap[s.tipo][cidadeid][c.idcliente].visible && this.visibilityMap[s.tipo][cidadeid][c.idcliente].inSearch
                    });
                });
            });

            this.markers = m;

            return body;
        },
        mapItemsStatus (body) {
            let total = 0;

            body.forEach(c => {
                total += c.clients.length;
            });

            this.totalClientes = total;

            return body.map(c => {
                return {
                    descricao: c.descricao,
                    tipo: c.tipo,
                    cities: [],
                    qtd: c.clients.length,
                    hasDetails: false,
                    detailsOpen: false,
                    isLoading: false
                }
            });
        },
        groupCity (body, status) {
            body.cities = [];
            
            body.clients.forEach(c => {
                if (c.cidade != undefined) {
                    let idx = body.cities.findIndex(city => {
                        return c.cidade.idcidade == city.id;
                    });

                    if (idx != -1) {
                        body.cities[idx].clientes.push(c);
                    } else {
                        body.cities.push({
                            id: c.cidade.idcidade,
                            clientes: [c],
                            nome: c.cidade != undefined ? c.cidade.descricao : undefined,
                            estado: c.estado != undefined ? c.estado.descricao : undefined,
                            detailsOpen: false
                        });
                    }
                } else {
                    let idx = body.cities.findIndex(city => {
                        return city.id == 0;
                    });

                    if (idx != -1) {
                        body.cities[idx].clientes.push(c);
                    } else {
                        body.cities.push({
                            id: 0,
                            clientes: [c],
                            nome: c.cidade != undefined ? c.cidade.descricao : undefined,
                            estado: c.estado != undefined ? c.estado.descricao : undefined,
                            detailsOpen: false
                        });
                    }
                }
            });

            return body;
        },
        switchSortTo(prop) {
            if (this.orderedBy != prop) {
                this.orderedBy = prop;
                this.orderedAsc = true;
            } else {
                this.orderedAsc = !this.orderedAsc;
            }

            this.orderStatusBy(prop, this.orderedAsc);
        },
        orderStatusBy(prop, asc) {
            switch (prop) {
                case 'descricao':
                    this.status.sort((a, b) => {
                        if (asc) {
                            return a.descricao.localeCompare(b.descricao);
                        } else {
                            return b.descricao.localeCompare(a.descricao);
                        }
                    });
                    break;
                case 'quantidade':
                    this.status.sort((a, b) => {
                        if (asc) {
                            return a.qtd - b.qtd;
                        } else {
                            return b.qtd - a.qtd;
                        }
                    });
                    break;
                case 'cliente':
                    this.status.forEach(s => {
                        if (s.cities != undefined) {
                            s.cities.forEach(c => {
                                c.clientes.sort((a, b) => {
                                    if (asc) {
                                        return a.rsocial.localeCompare(b.rsocial);
                                    } else {
                                        return b.rsocial.localeCompare(a.rsocial);
                                    }
                                });
                            });
                        }
                    });
                    break;
            }
        },
        searchClientes (val) {
            let requests = [];

            this.isSearching = true;
            this.searchVal = val;

            this.status.forEach(s => {
                if (s.hasDetails) {
                    requests.push(
                        this.service.findByStatus(s.tipo, this.filtro, this.searchVal)
                        .then(c => {
                            return this.groupCity(c, s)
                        })
                        .then(r => {
                            let sids = s.cities.map(c => c.id); // Cidades atuais
                            let cids = r.cities.map(c => c.id); // Cidades novas

                            let remover = sids.filter(x => !cids.includes(x));
                            let incluir = cids.filter(x => !sids.includes(x));
                            let modificar = sids.filter(x => cids.includes(x));

                            // Removendo do array os que não estão no novo
                            remover.forEach(item => {
                                let idx = s.cities.findIndex(cd => cd.id == item);

                                if (idx > -1) {
                                    s.cities.splice(idx, 1);
                                    this.visibilityMap[s.tipo][item].inSearch = false;
                                }
                            });

                            // Inlucindo os que vieram da request
                            incluir.forEach(item => {
                                let idx = r.cities.findIndex(cd => cd.id == item);

                                if (idx > -1) {
                                    s.cities.push(r.cities[idx]);
                                    this.visibilityMap[s.tipo][item].inSearch = true;
                                }
                            });

                            // Modificando os que estão em ambos por conta de clientes diferentes,
                            // para manter a marcação de visibilidade
                            modificar.forEach(item => {
                                let idxa = s.cities.findIndex(cd => cd.id == item);
                                let idxn = r.cities.findIndex(cd => cd.id == item);

                                if (idxn > -1 && idxa > -1) {
                                    let citya = s.cities[idxa]; // Clientes Atuais
                                    let cityn = r.cities[idxn]; // Clientes Novos
                                    
                                    let cla = citya.clientes.map(cl => cl.idcliente);
                                    let cln = cityn.clientes.map(cl => cl.idcliente);

                                    let rm = cla.filter(x => !cln.includes(x));
                                    let add = cln.filter(x => !cla.includes(x));
                                    
                                    // Removendo
                                    rm.forEach(i => {
                                        let idx = citya.clientes.findIndex(cd => cd.idcliente == i);

                                        if (idx > -1) {
                                            citya.clientes.splice(idx, 1);
                                            this.visibilityMap[s.tipo][citya.id][i].inSearch = false;
                                        }
                                    });

                                    // Incluindo
                                    add.forEach(i => {
                                        let idx = cityn.clientes.findIndex(cd => cd.idcliente == i);

                                        if (idx > -1) {
                                            citya.clientes.push(cityn.clientes[idx]);
                                            this.visibilityMap[s.tipo][citya.id][i].inSearch = true;
                                        }
                                    });
                                }
                            });

                            s.cities.sort((a, b) => {
                                return `${a.nome} - ${a.estado ? ` - ${a.estado}` : ''}`.localeCompare(`${b.nome} - ${b.estado ? ` - ${b.estado}` : ''}`);
                            });

                            this.$nextTick(function() {
                                let chks = this.$refs[`chk-${s.descricao}`];
                                let visibleCl = 0, invisibleCl = 0;

                                s.cities.forEach(c => {
                                    if (s.hasDetails) {
                                        let visible = 0, invisible = 0;
                                        let chk = this.$refs[`chk-${s.descricao}-${c.nome}-${c.estado}`];

                                        c.clientes.forEach((cl, i) => {
                                            this.visibilityMap[s.tipo][c.id][cl.idcliente].visible ? visible++ : invisible++;
                                        });

                                        if (chk != undefined && chk.length > 0) {
                                            chk[0].indeterminate = visible > 0 && invisible > 0;
                                        }

                                        this.visibilityMap[s.tipo][c.id].checked = visible > 0 && this.visibilityMap[s.tipo][c.id].visible;

                                        visibleCl += visible;
                                        invisibleCl += invisible;
                                    } else {
                                        c.clientes.forEach((cl, i) => { 
                                            this.visibilityMap[s.tipo][c.id][cl.idcliente].visible ? visibleCl++ : invisibleCl++;
                                        });
                                    }
                                });                                

                                if (chks != undefined && chks.length > 0) {
                                    chks[0].indeterminate = visibleCl > 0 && invisibleCl > 0;
                                }

                                this.visibilityMap[s.tipo].checked = this.visibilityMap[s.tipo].visible && visibleCl > 0;
                            });
                        })
                    );

                }
            });

            requests.push(
                this.service.findAll(this.filtro, val)
                    .then(this.getMarkers)
                    .then(this.mapItemsStatus)
                    .then(r => {
                        let recstatus = [];

                        this.status.forEach((s, i) => {
                            let chk = this.$refs[`chk-${s.descricao}`];
                            recstatus = r.find(sr => sr.tipo == s.tipo);

                            if (recstatus != undefined) {
                                s.qtd = recstatus.qtd;
                                
                                if (chk != undefined && chk.length > 0 && recstatus.qtd == 0) {
                                    chk[0].indeterminate = false;
                                }
                            }
                        });
                    })
            );

            // Executado quando todas as requests resolverem
            Promise.all(requests).then(() => {
                this.orderStatusBy(this.orderedBy, this.orderedAsc);
                this.updateHeatmap();
                this.isSearching = false;
            });
        },
        loadAtividades (val) {
            this.filterService.findAllAtividade(0, 50, val)
                      .then(this.mapItems)
                      .then(r => {
                          this.atividades = r;
                      });
        },
        loadRegioes (val) {
            this.filterService.findAllRegiao(0, 50, val)
                      .then(this.mapItems)
                      .then(r => {
                          this.regioes = r;
                      });
        },
        mapItems (body) {
            let list = body.content.map(i => {
                return {
                    id: i.id,
                    label: i.descricao
                };
            });

            return list;
        },
        removeFilter() {
            this.situacao = null;
            this.regiao = null;
            this.atividade = null;

            this.applyFilter();
        },
        applyFilter () {
            this.isSearching = true;

            this.filtro = {
                atividade: this.atividade != null ? {descricao: this.atividade.label} : null,
                situacao: this.situacao != null ? this.situacao.map((situacao) => ({idsituacao: situacao.id})) : null,
                regiao: this.regiao != null ? {descricao: this.regiao.label} : null
            };

            this.service
                .findAll(this.filtro, '')
                .then(this.getMarkers)
                .catch((error) => {
                    this.msgs.push(new Message("error", 'msg-erro-relatorio', true));
                    console.error('Erro ao aplicar filtro:');
                    console.error(error);
                });

            this.searchClientes(this.searchVal);
        },
        gmnoprintZindex() {
            // Removendo o z-index dos avisos de copyright do mapa para o aviso poder aparecer normal e em full screen
            document.querySelectorAll('.gmnoprint').forEach(e => {    
                if (e.style.zIndex) {
                    e.style.zIndex = 0;
                }
            });
        }
    }
};
</script>

<style lang="scss">
.search-input .search-wrapper{
    width: 100%;
    height: 27px !important; 
    border: 1px solid #e1e1e1;
    display: flex;
    position: relative;
    border-radius: 3px;
}
@mixin border() {
    border: 1px solid $table-border;
    border-radius: 3px;
}

.p-5-custom {
    padding: 10px;
}

#main {
    padding: 0px 20px;
    height: 100%;
}

h1.title {
    margin-bottom: 0 !important;
}

.page {
    position: relative;
}

h1.title {
    margin-right: 0;
}

.mapa-wrapper {
    height: calc(100vh - 150px);
}

.check-box {
    margin-bottom: 0;

    .checkmark {
        position: inherit;
        display: inline-flex;
        top: 0;
        right: 0;
        height: 16px;
        width: 16px;
        border: 2px solid $primary-color-hover;
        margin-top: 2px;
        border-radius: 3px;
    }
}

.control-right {
    .lista-status {
        width: 100%;
        height: calc(100% - 40px);
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
        padding: 0.75rem;
        color: #666666;

        .search-input {
            opacity: 0.9;
        }

        .table-controls {
            display: flex;
            border: 1px solid $table-border;
            border-top-left-radius: 5px;
            border-top-right-radius: 5px;
            border-bottom: 0;
            height: 1.5rem;
            margin-top: 0.4rem;
            align-items: center;
            font-weight: 600;

            .status-header {
                display: flex;
                align-items: center;
                justify-content: space-between;
                width: 70%;
                padding-left: 36px;
                height: 100%;
                cursor: pointer;

                &:hover{
                    background: $table-border;
                }
            }

            .cliente-header {
                display: flex;
                align-items: center;
                width: 30%;
                justify-content: space-between;
                padding-left: 5px;
                padding-right: 3px;
                height: 100%;
                cursor: pointer;

                &:hover{
                    background: $table-border;
                }
            }
        }

        .lista-wrapper {
            height: calc(100% - 4rem);
            margin-bottom: -0.75rem;

            .lista-container {
                border-left: 1px solid $table-border;
                border-right: 1px solid $table-border;
                margin: 0.75rem;
                overflow-y: scroll;

                &>.columns.is-multiline {
                    margin: 0;
                }

                .lista-item, .lista-cidades, .lista-clientes {
                    cursor: pointer;

                    .status-info {
                        display: flex; 

                        .info-left {
                            display: flex;
                            align-items: center;

                            .check-div {
                                width: 20px;
                                height: 20px;
                            }

                            .text {
                                padding-left: 5px;
                            }
                        }

                        .info-right {
                            display: flex;
                            align-items: center;
                            justify-content: flex-end;
                            width: 100px;
                        }
                    }
                }

                .lista-item {
                    padding: 0.25rem;

                    .status-info .info-left {
                        width: calc(100% - 100px);
                    }
                }

                .lista-cidades, .lista-clientes {
                    padding: 0.25rem 0 0.25rem 1.25rem;

                    .status-info .info-left {
                        width: 100%;
                    }
                }

                .lista-clientes .status-info .info-left {
                    align-items: flex-start;
                }
            }
        }

        .table-count {
            display: flex;
            border: 1px solid $table-border;
            border-bottom-left-radius: 5px;
            border-bottom-right-radius: 5px;
            height: 1.5rem;
            align-items: center;
            justify-content: space-around;
            font-weight: 600;
        }
    }
}
</style>